<template>
  <!--本地 icon 资源, uniapp 打包到 app 仅支持标签 image, 打包小程序和 H5 均可支持标签 img -->
  <div class="common-icon-container">
    <img
      class="common-icon"
      :src="props.src"
      :style="{ width: props.width, height: props.height }"
    >
  </div>
</template>
<script lang="ts">

interface Props {
  src: string;
  width?: string;
  height?: string;
}

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '16px',
    },
    height: {
      type: String,
      default: '16px',
    },
  },
  setup(props: Props) {
    return {
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
.common-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
